import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, isRef as _isRef, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ab89ccfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "loader" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "top-content"
}
const _hoisted_5 = { class: "center-dropdown-table-container" }
const _hoisted_6 = { class: "center-dropdown-table" }
const _hoisted_7 = { style: {"font-weight":"bold"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Select Contract Owner: ", -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Owner Assignment Date: ", -1))
const _hoisted_11 = {
  class: "date-picker",
  style: {"padding-top":"5px"}
}
const _hoisted_12 = {
  class: "center-buttons",
  style: {"margin-top":"0px"}
}
const _hoisted_13 = ["disabled", "title"]
const _hoisted_14 = {
  colspan: "3",
  style: {"padding-top":"10px","font-weight":"normal"}
}
const _hoisted_15 = { class: "center-buttons" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  class: "incident-nav-button-fake",
  style: {"margin-left":"0.7rem"}
}
const _hoisted_19 = { style: {"padding-bottom":"5rem"} }

import { inject, computed, ref, onMounted } from "vue";
// Services
import { FunctionAccessLevels, DenyFunctionLevelAccess } from "@/config/AuthConfig";
import { CurrencySymbol, MarketCurrency, MonetaryValueWithCommas } from "@/services/helpers/Helper";
import useVars from "@/services/helpers/CarPurchases/CarPurchasesVariables";
import { FormatDatePicker } from "@/services/helpers/CarPurchases/CarPurchasesFunctions";
// Components
import Table from "@/components/TablePersistentChecking.vue";
import Popup from '@/components/Popup.vue';
import DatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
// Misc
import log from "loglevel";
import { globalReloadKey } from "@/types/ServiceKeys";
import { CarPurchasesPaymentRequest } from "@/models/CarPurchases/CarPurchasesPaymentRequest";
import { CarPurchasesCarSaleInvoice } from "@/models/CarPurchases/CarPurchasesCarSaleInvoice";
import { DisplayableKeys } from "@/services/SorterService";
import { ISelection } from "@/Interfaces/ISelection";
import { ContractOwner } from "@/models/CarPurchases/ContractOwner";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";


export default /*#__PURE__*/_defineComponent({
  __name: 'CarPurchasesPopup',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue", "close", "confirm"],
  setup(__props: any, { emit: __emit }) {

const contractOwnersSelections = ref<ISelection[]>([]);
const contractOwners = ref<ContractOwner[]>([]);

onMounted(()=>{
    GetContractOwners()  
})
async function GetContractOwners() {
    const name = GetContractOwners.name;
    const prefix = name + "()\n";
    var Message = `Getting Contract Owners`;
    log.debug(`${prefix}${Message}`);

    try {
        infoError.value = undefined;
        fetchingContractOwners.value = true;
        const res = await carPurchasesServices.GetContractOwners<ContractOwner[]>();
        contractOwners.value = res.data;
        contractOwnersSelections.value = res.data.map((contractOwner: ContractOwner) => {
            return {
                text: contractOwner.FullName,
                val: contractOwner.OwnerId
            } as ISelection;
        });
    } catch (error) {
        useNotifierWithErrFormatter().error({ errorType: "Getting Contract Owners", error})
        infoError.value = error;
    } finally {
        fetchingContractOwners.value = false;
    }
}

const emits = __emit;
const props = __props;
const confirmCarPurchaseRows = computed({
    get() {
        return props.modelValue;
    },
    set(val) {
        emits('update:modelValue', val);
    }
});
const currentCurrencySymbol = computed(()=>{    
    let marketValue = confirmCarPurchaseRows.value?.[0].MARKET
    if(marketValue != undefined && marketValue != null ){
        return CurrencySymbol[MarketCurrency[marketValue]]
    }
    else{
        return  CurrencySymbol[MarketCurrency['GBP']]
    }
})
const reload = inject(globalReloadKey);
const {
    carPurchasesServices,
    selectedContractOwner,
    fetchingContractOwners,
    market,
} = useVars();

const confirmCarPurchaseCols: DisplayableKeys<CarPurchasesCarSaleInvoice>[] = [
	"CONTRACT_ID",
	"INVOICE_ID",
	"MARKET",
	"AMOUNT_TOTAL",
	"ISSUE_DATE",
	"BALANCE",
];
const confirmCarPurchaseLabels = [
	"Contract Id",
	"Invoice Id",
	"Market",
	"Amount Total",
	"Issue Date",
	"Balance",
];
const textInputOptions = { format: 'yyyy/MM/dd' };
const ownerAssignmentDate = ref<Date>();

const confirmingCarPurchases = ref(false);
const infoError = ref();

const confirmCarPurchaseDisabled = computed(
	() => {
		return (
			selectedContractOwner.value.length == 0
			|| ownerAssignmentDate.value == undefined
		);
	}
);
const confirmCarPurchaseRowsTotalBalance = computed(
	() => {
		return confirmCarPurchaseRows.value?.reduce(
			(sum: number, CSI: CarPurchasesCarSaleInvoice) => sum + (CSI.BALANCE ?? 0),
			0
		);
	}
);
const confirmCarPurchaseRowsTotalExVATBalance = computed(
	() => {
		return confirmCarPurchaseRows.value?.reduce(
			(sum: number, CSI: CarPurchasesCarSaleInvoice) => sum + (CSI.AMOUNT_EX_VAT ?? 0),
			0
		);
	}
);
const confirmCarPurchaseRowsTotalVATBalance = computed(
	() => {
		return confirmCarPurchaseRows.value?.reduce(
			(sum: number, CSI: CarPurchasesCarSaleInvoice) => sum + (CSI.AMOUNT_VAT ?? 0),
			0
		);
	}
);

function close(refresh = false) {
    confirmCarPurchaseRows.value = undefined;
    ownerAssignmentDate.value = undefined;
    if (refresh) reload?.();
}

async function ConfirmCarPurchases() {
    if (confirmingCarPurchases.value) return;
    confirmingCarPurchases.value = true;
    const baseMsg = 'Confirming Car Purchases';
    try {
        if (!confirmCarPurchaseRows.value) throw new ReferenceError('confirmCarPurchaseRows is unexpectedly undefined');
        const Message = `${baseMsg} (Car Sale Invoice IDs: ${confirmCarPurchaseRows.value?.map(x=>x.CONTRACT_ID).join(", ")})`;
        log.debug(Message);
        const res = await carPurchasesServices.ConfirmCarPurchasesPayment<CarPurchasesPaymentRequest>({
			collectiveInvoiceId: confirmCarPurchaseRows.value[0].COLLECTIVE_INVOICE_ID,
			confirmCarPurchaseRows: confirmCarPurchaseRows.value,
			confirmCarPurchaseRowsTotalBalance: confirmCarPurchaseRowsTotalBalance.value,
			confirmCarPurchaseRowsTotalExVATBalance: confirmCarPurchaseRowsTotalExVATBalance.value,
			confirmCarPurchaseRowsTotalVATBalance: confirmCarPurchaseRowsTotalVATBalance.value,
			market: market.value,
			ownerAssignmentDate: ownerAssignmentDate.value,
			selectedContractOwner: selectedContractOwner.value,
        });
        useNotifierWithErrFormatter().success({msg: "Car Purchase successfully registered."})
        close(true);
    } catch(error) {
        infoError.value = error;
        useNotifierWithErrFormatter().error({error, errorType: "Confirming Car Purchases"})
        //(Confirming Car Purchases)
    } finally {
        confirmingCarPurchases.value = false;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    "model-value": !!confirmCarPurchaseRows.value,
    "onUpdate:modelValue": close,
    "has-close": "",
    title: confirmingCarPurchases.value
        ? 'Confirming Car Purchases:'
        : 'Confirm Car Purchases:'
        
  }, _createSlots({ _: 2 }, [
    (confirmCarPurchaseRows.value)
      ? {
          name: "contents",
          fn: _withCtx(() => [
            (_unref(fetchingContractOwners) || confirmingCarPurchases.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
              : (!_unref(DenyFunctionLevelAccess)(_unref(FunctionAccessLevels).CarPurchasesAssignToOwner))
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("tbody", _hoisted_7, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", null, [
                              _hoisted_8,
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedContractOwner) ? (selectedContractOwner).value = $event : null)),
                                class: "dropdown"
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contractOwnersSelections.value, (contractOwner) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: contractOwner.text,
                                    key: contractOwner.val
                                  }, _toDisplayString(contractOwner.text), 9, _hoisted_9))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, _unref(selectedContractOwner)]
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _hoisted_10,
                              _createElementVNode("div", _hoisted_11, [
                                _createVNode(_unref(DatePicker), {
                                  modelValue: ownerAssignmentDate.value,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ownerAssignmentDate).value = $event)),
                                  type: "date",
                                  "enable-time-picker": false,
                                  format: _unref(FormatDatePicker),
                                  placeholder: "Select Date...",
                                  "text-input-options": textInputOptions,
                                  "text-input": ""
                                }, null, 8, ["modelValue", "format"])
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("button", {
                                  class: "incident-nav-button",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (ConfirmCarPurchases())),
                                  disabled: confirmCarPurchaseDisabled.value,
                                  title: confirmCarPurchaseDisabled.value
                                                ? 'Select Contract Owner and Owner Assignment Date to Confirm Car Purchase'
                                                : `Confirm '${_unref(selectedContractOwner)} ' Car Purchase for ${_unref(MonetaryValueWithCommas)(confirmCarPurchaseRowsTotalBalance.value)}`,
                                  style: {"width":"100%","margin-top":"1rem"}
                                }, " Confirm Purchase ", 8, _hoisted_13)
                              ])
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, [
                                (_unref(selectedContractOwner).length > 0 && ownerAssignmentDate.value !== undefined)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                      _createElementVNode("div", null, [
                                        _createElementVNode("strong", null, _toDisplayString(_unref(selectedContractOwner)) + "'", 1),
                                        _createTextVNode(" will be assigned "),
                                        _createElementVNode("strong", null, _toDisplayString(confirmCarPurchaseRows.value.length), 1),
                                        _createTextVNode(" cars on "),
                                        _createElementVNode("strong", null, _toDisplayString(_unref(FormatDatePicker)(ownerAssignmentDate.value)), 1),
                                        _createTextVNode(" for a total purchase price of: ")
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_17, " Total purchase price: ")),
                                _createElementVNode("button", _hoisted_18, _toDisplayString(currentCurrencySymbol.value+_unref(MonetaryValueWithCommas)(confirmCarPurchaseRowsTotalBalance.value)), 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_19, [
              (!(_unref(fetchingContractOwners) || confirmingCarPurchases.value) && !_unref(DenyFunctionLevelAccess)(_unref(FunctionAccessLevels).CarPurchasesAssignToOwner))
                ? (_openBlock(), _createBlock(Table, {
                    key: 0,
                    Rows: confirmCarPurchaseRows.value,
                    Cols: confirmCarPurchaseCols,
                    Labels: confirmCarPurchaseLabels
                  }, {
                    AMOUNT_TOTAL: _withCtx((props) => [
                      _createTextVNode(_toDisplayString(_unref(MonetaryValueWithCommas)(props.value.AMOUNT_TOTAL)), 1)
                    ]),
                    BALANCE: _withCtx((props) => [
                      _createTextVNode(_toDisplayString(_unref(MonetaryValueWithCommas)(props.value.BALANCE)), 1)
                    ]),
                    _: 1
                  }, 8, ["Rows"]))
                : _createCommentVNode("", true)
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["model-value", "title"]))
}
}

})